import { render } from "./project_dormitory.vue?vue&type=template&id=11cdd5ab&scoped=true"
import script from "./project_dormitory.vue?vue&type=script&lang=js"
export * from "./project_dormitory.vue?vue&type=script&lang=js"

import "./project_dormitory.vue?vue&type=style&index=0&id=11cdd5ab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cdd5ab"]])

export default __exports__